import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Container} from 'reactstrap';

import OwnerProperties from './properties/OwnerProperties';

class OwnerDashboard extends Component {
    render() {
        return (
            <Container>
                <OwnerProperties/>
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(OwnerDashboard);


// WEBPACK FOOTER //
// ./src/containers/owner/OwnerDashboard.js